export default __webpack_public_path__ + "static/media/80t.54e36214.jpg";